import React from 'react';

import ParcelIcon from 'assets/parcel.svg';

import { useArticles } from '../../hooks/shipment.hooks';
import { SERVICE_FEATURES_TEST_ID } from '../DetailsPanel.test-ids';

import styles from './ServiceFeatures.module.scss';

const ServiceFeatures: React.FC = () => {
  const articleType = useArticles()?.[0]?.articleType;

  const displayServices = () => {
    if (!articleType) return null;
    return (
      <div className={styles.row}>
        <ParcelIcon className={styles.serviceIcon} />
        <p className={styles.textContent}>{articleType}</p>
      </div>
    );
  };

  return (
    <div className={styles.serviceFeatures} data-testid={SERVICE_FEATURES_TEST_ID}>
      {!articleType ? <p className={styles.textContent}>Not available</p> : <>{displayServices()}</>}
    </div>
  );
};

export default ServiceFeatures;
